import React, { useMemo } from "react";
import { BlockStack, InlineStack, Tag, Text } from "@shopify/polaris";
import { EXCLUDE_PAGE_TYPE_OPTIONS } from "./ExcludePagesModal";

export default function ExcludedPagesSummary({ excludedPages }) {
  const labels = useMemo(() => {
    const types = excludedPages?.page_types || [];
    const labelByValue = Object.fromEntries(EXCLUDE_PAGE_TYPE_OPTIONS.map((o) => [o.value, o.label]));
    return types.map((t) => labelByValue[t] || t);
  }, [excludedPages?.page_types]);

  const urls = excludedPages?.specific_urls || [];
  const keywords = excludedPages?.url_keywords || [];
  const hasSummary = labels.length || urls.length || keywords.length;

  if (!hasSummary) {
    return (
      <Text as="p" variant="bodySm" tone="subdued">
        No pages excluded.
      </Text>
    );
  }

  return (
    <BlockStack gap="200">
      {labels.length ? (
        <InlineStack gap="200" wrap>
          {labels.map((label) => (
            <Tag key={label}>{label}</Tag>
          ))}
        </InlineStack>
      ) : null}
      {urls.length ? (
        <BlockStack gap="100">
          <Text as="p" variant="bodySm" tone="subdued">
            Specific URLs
          </Text>
          <InlineStack gap="200" wrap>
            {urls.map((url) => (
              <Tag key={url}>{url}</Tag>
            ))}
          </InlineStack>
        </BlockStack>
      ) : null}
      {keywords.length ? (
        <BlockStack gap="100">
          <Text as="p" variant="bodySm" tone="subdued">
            URL keywords
          </Text>
          <InlineStack gap="200" wrap>
            {keywords.map((kw) => (
              <Tag key={kw}>{kw}</Tag>
            ))}
          </InlineStack>
        </BlockStack>
      ) : null}
    </BlockStack>
  );
}
